import { AfterViewChecked, Directive, ElementRef, HostListener, Input, NgModule, OnDestroy, Renderer2 } from "@angular/core";
import { Calendar, CalendarModule } from "primeng/calendar";
import { Subscription } from "rxjs";
import { MaskingBase } from "./masking_base";

@Directive({
    selector: "p-calendar[rPCalendarMask]"
})
export class PrimeNgCalendarMaskDirective extends MaskingBase implements AfterViewChecked, OnDestroy {
    oldValueDate: any;
    private selectSubscriber: Subscription;
    private listener: () => void;

    constructor(private el: ElementRef, private host: Calendar, private renderer: Renderer2) {
        super();
    }
    @Input() isNotNull = false;
    @Input() customDateFormat;
    @Input() selectAllOnFocus = true;

    @Input() set slotChar(value: string) {
        this._slotChar = value;
    }

    @Input() set showPlaceholder(value: boolean) {
        this._showPlaceholder = value;
    }
    @Input() set overwriteOnInsert(value: boolean) {
        this._overwriteOnInsert = value;
    }

    private firstTime = true;

    private setMask() {
        this._mask = "";
        if (!this.host.timeOnly) {
            let dateFormat = this.customDateFormat || this.host.dateFormat;
            for (let dateFormatItem of dateFormat) {
                if (dateFormatItem === "d" || dateFormatItem === "m" || dateFormatItem === "y") {
                    this._mask += "9";
                    if (dateFormatItem === "y") {
                        this._mask += "9";
                    }
                } else {
                    this._mask += dateFormatItem;
                }
            }
        }
        if (this.host.showTime || this.host.timeOnly) {
            if (!this.host.timeOnly) {
                this._mask += " ";
            }
            this._mask += "99:99";
            if (this.host.showSeconds) {
                this._mask += ":99";
            }
        }
    }

    @HostListener("input")
    private onInput() {
        if (this._input === null) {
            this._input = this.host.inputfieldViewChild.nativeElement;
        }
        this.checkValue();
    }

    @HostListener("onFocus")
    private whenFocus(){
        this.oldValueDate = this._input.value;
    }

    @HostListener("keydown", ["$event"]) onKeyDown(e: KeyboardEvent) {
        if (e.keyCode == 84) {
            e.preventDefault();
            e.stopPropagation();
            let date = new Date();// default date now
            if (this.host.isSelectable(date.getDate(), date.getMonth(), date.getFullYear(), false)) {
                this.host.updateModel(date);
                this.host.writeValue(date.getDate().toString() + "/" + (date.getMonth() + 1).toString() + "/" + date.getFullYear());// write UI
            }
        }
    }

    @HostListener("dblclick") dbclick() {
        this.host.toggle();
    }

    @HostListener("focusout")
    private onBlur() {
        this.host.inputfieldViewChild.nativeElement.style.backgroundColor = "white";
        if (this.oldValueDate != this.value) {
            //30-10-2019
            if (this.value.length > 0 && this.value.length < 11 && this.value.indexOf(this._slotChar) === -1) { // length = 10 . function this.updateInput has handled
                try {
                    if(!this.host.timeOnly){
                        let today = new Date();
                        let dateFormat = this.customDateFormat || this.host.dateFormat;
                        if (dateFormat == "mm/yy") {
                            // 01/2021
                            // switch (this.value.length) {
                            //     case 1: {
                            //         this.value = "0" + (this.value.toString() == "0" ? "1" : this.value) + "/" + today.getFullYear();
                            //         break;
                            //     }
                            //     case 2: {
                            //         this.value = this.value  + "/" + today.getFullYear();
                            //         break;
                            //     }
                            //     case 4: {
                            //         this.value = this.value.substring(0, 3) + "200" + this.value.substring(3, 4);
                            //         break;
                            //     }
                            //     case 5: {
                            //         this.value = this.value.substring(0, 3) + "20" + this.value.substring(3, 5);
                            //         break;
                            //     }
                            //     case 6: {
                            //         this.value = this.value.substring(0, 3) + "2" + this.value.substring(3, 6);
                            //         break;
                            //     }
                            //     case 7: {
                            //         this.value = this.value;
                            //         break;
                            //     }
                            // }
                            // console.log(this.value)
                            // let date = this.host.parseDate(this.value, 'mm/yy');// default is dd-mm-yy if formatDate not define
                            // console.log(date)
                            // if (this.host.isSelectable(date.getDate(), date.getMonth(), date.getFullYear(), false)) {
                            //     this.host.updateModel(date);
                            //     this.host.writeValue(this.value);// write UI
                            // }
                        }
                        else {
                            // 01/01/2021
                            switch (this.value.length) {
                                case 1: {
                                    this.value = "0" + this.value + "/" + ("0" + (today.getMonth() + 1)).slice(-2) + "/" + today.getFullYear();
                                    break;
                                }
                                case 2: {
                                    this.value = this.value + "/" + ("0" + (today.getMonth() + 1)).slice(-2) + "/" + today.getFullYear();
                                    break;
                                }
                                case 4: {
                                    this.value = this.value.substring(0, 2) + "/0" + this.value.substring(3, 4) + "/" + today.getFullYear();
                                    break;
                                }
                                case 5: {
                                    this.value = this.value + "/" + today.getFullYear();
                                    break;
                                }
                                case 7: {
                                    this.value = this.value.substring(0, 6) + "200" + this.value.substring(6, 7);
                                    break;
                                }
                                case 8: {
                                    this.value = this.value.substring(0, 6) + "20" + this.value.substring(6, 8);
                                    break;
                                }
                                case 9: {
                                    this.value = this.value.substring(0, 6) + "2" + this.value.substring(6, 9);
                                    break;
                                }
                                case 10: {
                                    this.value = this.value;
                                    break;
                                }
                            }
                            let date = this.host.parseDate(this.value, 'dd/mm/yy');// default is dd-mm-yy if formatDate not define
                            if (this.host.isSelectable(date.getDate(), date.getMonth(), date.getFullYear(), false)) {
                                this.host.updateModel(date);
                                this.host.writeValue(this.value);// write UI
                            }
                        }
                    }
                    else{
                    }
                } catch (err) {
                    if(!this.host.timeOnly){
                        if(this.isNotNull){
                            try {
                                let date = this.host.parseDate(this.oldValueDate, 'dd/mm/yy');// default is dd-mm-yy if formatDate not define
                                if (this.host.isSelectable(date.getDate(), date.getMonth(), date.getFullYear(), false)) {
                                    this.host.updateModel(date);
                                    this.host.writeValue(this.oldValueDate);// write UI
                                }
                            } catch (err) {
                                let date = this.host.parseDate("01/01/1900", 'dd/mm/yy');// default is dd-mm-yy if formatDate not define
                                if (this.host.isSelectable(date.getDate(), date.getMonth(), date.getFullYear(), false)) {
                                    this.host.updateModel(date);
                                    this.host.writeValue(this.oldValueDate);// write UI
                                }
                            }
                            
                        }
                        else this.host.updateModel(null);
                    }
                    else{
                        if(this.isNotNull){
                            this.host.value = new Date();
                            this.host.updateTime();
                            this.host.updateUI();
                        }
                    }
                }
            }
            else{
                if(!this.host.timeOnly){
                    if(this.isNotNull){
                        try {
                            let date = this.host.parseDate(this.oldValueDate, 'dd/mm/yy');// default is dd-mm-yy if formatDate not define
                            if (this.host.isSelectable(date.getDate(), date.getMonth(), date.getFullYear(), false)) {
                                this.host.updateModel(date);
                                this.host.writeValue(this.oldValueDate);// write UI
                            }
                        } catch (err) {
                            let date = this.host.parseDate("01/01/1900", 'dd/mm/yy');// default is dd-mm-yy if formatDate not define
                            if (this.host.isSelectable(date.getDate(), date.getMonth(), date.getFullYear(), false)) {
                                this.host.updateModel(date);
                                this.host.writeValue(this.oldValueDate);// write UI
                            }
                        }
                        
                    }
                    else this.host.updateModel(null);
                }
                else{
                    if(this.isNotNull){
                        this.host.value = new Date();
                        this.host.updateTime();
                        this.host.updateUI();
                    }
                }
            }
        }

    }

    private onFocus() {
        this.host.inputfieldViewChild.nativeElement.style.backgroundColor = "yellow";
        if (this.customDateFormat && this.host.value) {
            this._input.value = this.value;
            this.checkValue(true);
            if (!this.selectAllOnFocus) {
                this._input.selectionStart = this.value.length;
                this._input.selectionEnd = this.value.length;
            }
            return;
        }
        this.checkValue(true);
    }

    public updateInput() {
        super.updateInput();
        if (this.selectAllOnFocus && this.focus) {
            this._input.selectionStart = 0;
            this._input.selectionEnd = this.value.length;
        }
    }

    ngAfterViewChecked(): void {
        if (this.firstTime && this.host && this.host.inputfieldViewChild) {
            this.firstTime = false;
            this._input = this.host.inputfieldViewChild.nativeElement;
            this._input.type = "tel";
            this.setMask();
            this.listener = this.renderer.listen(this._input, "focus", () => {
                this.onFocus();
            });
            this.selectSubscriber = this.host.onSelect.subscribe((value) => {
                this.onSelect(value);
            });
        }
    }

    private onSelect(value) {
        if (this.customDateFormat) {
            let formattedValue = "";

            if (this.host.timeOnly) {
                formattedValue = this.host.formatTime(value);
            } else {
                formattedValue = this.host.formatDate(value, this.customDateFormat);
                if (this.host.showTime) {
                    formattedValue += " " + this.host.formatTime(value);
                }
            }
            this.value = formattedValue;
        }
    }

    ngOnDestroy(): void {
        this.listener();
        this.selectSubscriber.unsubscribe();
    }
}

@NgModule({
    imports: [
        CalendarModule
    ],
    declarations: [
        PrimeNgCalendarMaskDirective
    ],
    exports: [
        PrimeNgCalendarMaskDirective
    ]
})
export class PrimeNgCalendarMaskModule {

}
